<script>
  var images = require.context('../assets/images/', true)
  export default{
    name: 'lote-info',
    props: ['lote'],
    data () {
      return {
      }
    },
    computed: {},
    mounted () {
      if (this.lote.imagem === null) {
        this.lote.imagem = images('./noimg.jpg')
      }
    },
    destroyed () {
    },
    methods: {},
    components: {}
  }
</script>

<template>
  <div class="lote-info">
    <div class="lote-img">
      <img :src="lote.imagem">
    </div>
    <div class="lote-detalhes">
      <table>
        <tr>
          <td>Comitente</td>
          <td>{{ lote.comitente.pessoa.nome }}</td>
        </tr>
        <tr>
          <td>Descrição</td>
          <td>{{ lote.descricao }}</td>
        </tr>
        <tr>
          <td>LANCE INICIAL</td>
          <td>R$ {{ lote.valorInicial | moeda }}</td>
        </tr>
        <tr>
          <td>INCREMENTO</td>
          <td>R$ {{ lote.valorIncremento | moeda }}</td>
        </tr>
        <tr>
          <td>MÍNIMO</td>
          <td>R$ {{ lote.valorMinimo | moeda }}</td>
        </tr>
        <tr>
          <td>META</td>
          <td>R$ {{ lote.valorMeta | moeda }}</td>
        </tr>
      </table>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// LoteInfo.vue?403abe10